var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":"https://static.jipink.com/base/logo.png","width":"100"}}),_c('p',[_c('a',{attrs:{"href":"https://jipink.com","title":"Jipink"}},[_vm._v("Jipink")]),_vm._v(" © "+_vm._s((new Date().getFullYear()))+". All Rights Reserved. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }